import React, { useEffect, useRef, useState } from "react";
import StyleWrapper from "./style";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import LeadAccord from "application/motor/components/LeadAccord";
import LanguageSwitcherMobile from "_shared/LanguageSwitcherMobile";
import VehicleCard from "./components/VehicleCard";
import MobileNumber from "./components/MobileNumber/MobileNumber";
import LeadProductCard from "./components/ProductCard";
import { createQuotation, getDriverDetails, getProposal } from "services/motorRetailService";
import {
  UpdateQuotation,
  updateCustomerDetails,
  updateInceptionDate,
  updateLocalDriver,
  updateVehiclesDetails,
} from "redux/actions/motorActions";
import { VEHICLE_OBJECT } from "application/motor/helpers/models";
import { Toast } from "primereact/toast";

import {
  getGregYearOfBirthList,
  isValidSaudiPhoneNumber,
  numberWithCommas,
  prepareMobileNumber,
  validateEmail,
} from "helpers/utils";
import { ReactComponent as FullLogo } from "../../../../assets/images/logos/Tawuniya-Logo.svg";
import { config as globalConfig } from "../../../../config";

import LeadInput from "./components/Input.js/Input";
import { Button } from "primereact/button";
import { updateLoading } from "redux/actions/commonActions";
import { Divider } from "primereact/divider";
import { IdentificationList } from "helpers/utils";
import Declaration from "./components/Declaration/Declaration";
import OtherInfo from "./components/OtherInfo/OtherInfo";
import { ProgressBar } from "primereact/progressbar";
// const [defaultNationality, setDefaultNationality] = useState(default_Nationality);
import loaderLogo from "assets/images/icons/logo.svg";
import Calender from "./components/calender";
import { submitCRMCampaignApi } from "services/commonServices";
import  useEncryptDecrypt  from "helpers/use-decrypt";

const LeadPolicyDetails = (props) => {
  const { vehicles, customerDetails, personalFormDetails, tmxVehicleDetails, leadInceptionDate } =
    useSelector((state) => state.motor);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const businessLine = "elm";
  const [proposalArray, setProposalArray] = useState([]);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [selectedProposalArray, setSelectedProposalArray] = useState([]);
  const [retryCount, setRetryCount] = useState(0);
  const [validToGo, setValidToGo] = useState(true);
  const toast = useRef(null);
  const allowedProp = ["MotorImtiazeTP", "PRMotorImtiazeSP", "PRMotorImtiazeCO"];
  const [isSubmitting, setIsSubmitting] = useState(false);
  const refInfo = useRef(null);
  const encryptDecryptData = useEncryptDecrypt()
  const JWT = useSelector((state) => state.common.JWT);
  const scrollTo = (ref) => {
    if (ref && ref.current /* + other conditions */) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  //---------------------------------------------------------------
  // data form
  const formik = useFormik({
    initialValues: {
      proposalCode: "",
      vehicleList: [],
      mobile: prepareMobileNumber(customerDetails.mobile, false, true),
      email: customerDetails.email,
      ///////////////////
      //KYC

      nationalId: personalFormDetails?.nationalId,
      identificationType:
        personalFormDetails?.nationalId[0] === "1"
          ? IdentificationList[0]
          : personalFormDetails?.nationalId[0] === "2"
          ? IdentificationList[3]
          : personalFormDetails?.nationalId[0] === "3"
          ? IdentificationList[2]
          : IdentificationList[1],
      placeofIssue: "",
      expDate: new Date(customerDetails?.iqamaExpiryDate),
      FullName: "",
      dateofBirth: new Date(customerDetails?.gregDob?.split("-")?.reverse()?.join("-")),
      placeofbirth: "",
      Nationality: "",
      MaritalStatus: {
        maritalStatus: "UnMarried",
        maritalStatusCode: "U",
      },
      sourceofIncome: { code: "Other", description: "Other" },
      City: customerDetails?.cityCode || "38",
      Zone: customerDetails?.regionCode || "1",
      Disctrict: customerDetails?.homeWaselEngDistrictName || "Riyadh",
      Street:
        customerDetails?.officeWaselEngStreetName ||
        customerDetails?.homeWaselEngStreetName ||
        "Riyadh",
      buildingNo:
        customerDetails?.homeWaselBuildingNumber ||
        customerDetails?.officeWaselBuildingNumber ||
        "0000",
      UnitNo: customerDetails?.officeSelfUnitNumber || "0000",
      ZipCode: customerDetails?.zipCode || customerDetails?.officeWaselPostalCode || "0000",
      Additionalnumber: customerDetails?.officeWaselAdditionalNumber || "0000",
      Attoney: "No",
      Policyowner: "Yes",
      PoliticallyExposed: "No",
      RoyalMember: "No",
      RelatedParty: "No",
      Occupationyes: "",
      Rankyes: "",
      Occupation: {
        occupationDescription: customerDetails?.occupationName || "Other",
        occupationCode: customerDetails?.occupationCode || "2",
      },
      Rank: "",
      Relevant: "",
      Employer: "",
      politicalValue: "No",
      AuthAuthroney: "",
      authnumber: "",
      atidcardNo: "",
      atdateofExpiry: "",
      atdateofBIRTH: "",
      atplaceofbirth: "",
      atrelationship: "",
      atauthrization: "",
      atCity: "",
      atDistract: "",
      atAdditionalnumber: "",
      atZipCode: "",
      atUnitNo: "",
      atbuildingNo: "",
      atStreet: "",
      attDisctrict: "",
      atnatZone: "",
      atNatCity: "",
      PolicyOName: "",
      PolciyidCard: "",
      PolcyNationality: "",
      atPolicyrelationship: "",
      Payjust: "",
    },
    validate: (data) => {
      let errors = {};

      if (!data.proposalCode) {
        errors.proposalCode = t("proposal_code_required");
      }

      if (!data.vehicleList.length) {
        errors.vehicleList = t("vehicle_list_required");
      }

      if (!data.mobile) {
        errors.mobile = t("motor_person.mob_require");
      } else if (!isValidSaudiPhoneNumber(prepareMobileNumber(data.mobile, true, true))) {
        errors.mobile = t("motor_person.mob_not_require");
      }

      if (!data.email) {
        errors.email = t("motor_person.email_require");
      } else if (!validateEmail(data.email)) {
        errors.email = t("ERROR.EMAIL_NOT_VALID");
      }

      return errors;
    },

    onSubmit: (data) => {
      if (!leadInceptionDate) {
        scrollTo(refInfo);
        return;
      }

      if (
        data.PoliticallyExposed !== "No" ||
        data.RoyalMember !== "No" ||
        data.RelatedParty !== "No"
      ) {
        navigate("/lead/kit/pep", {
          state: { lead: location.state?.lead, tmx: location.state?.tmx },
          replace: true,
        });
        return;
      }

      setIsSubmitting(true);

      dispatch(updateLoading(true));

      const tempVehicles = [];

      dispatch(
        updateCustomerDetails({
          personalDetails: {
            ...personalFormDetails,
            email: data.email,
          },
          customerDetails: {
            ...customerDetails,
            mobile: prepareMobileNumber(data.mobile),
            email: formik.values.email,
          },
        })
      );

      vehicles.forEach((v) => {
        if (data.vehicleList.find((e) => e === v.chassisNumber)) tempVehicles.push(v);
      });

      dispatch(updateVehiclesDetails(tempVehicles));

      createQuotation(
        {
          productCode: data.proposalCode,
        },
        businessLine
      )
        .then((res) => {
          if (res.data?.resultCode === "S") {
            dispatch(UpdateQuotation(res.data));
            const quotationDetails = res.data;
            // const EncryptedID = window.btoa(quotationDetails?.idNumber);
            // const EncryptedproductCode = window.btoa(quotationDetails?.productCode);
            // const EncryptedquotationNumber = window.btoa(quotationDetails?.quotationNumber);
            dispatch(updateInceptionDate(null));

            if (quotationDetails?.quotationNumber) {
              submitCRMCampaignApi(quotationDetails?.quotationNumber, "ELM");
            }


            const dataObject = {
              idNumber: quotationDetails?.idNumber,
              quoteNumber: quotationDetails?.quotationNumber,
              product: quotationDetails?.productCode || 'MOTOR',
              language: i18n.language === 'A' ? 'AR' : 'EN',
              authToken: JWT,
              gdpNumber: '',
              policyNumber: '',
              quotationDocumentLink: '',
              isInternal: true,
              subProduct: 'ELM Lead'
            }
            const redirectPaymentBaseURL = `${window.location.protocol}//${window.location.host}/one-page-payment/payment?`
            const encryptedData = encryptDecryptData({
              data: dataObject,
              secretPass: process.env.REACT_APP_FOREIGN_KEY_MOTOR,
              encrypt: true,
              isObjectData: true,
            })
            window.location.replace(`${redirectPaymentBaseURL}id=${encryptedData}`)


            // window.location.href = `${globalConfig.redirectDomainUrl}/motor/payment?id=${EncryptedID}&productCode=${EncryptedproductCode}&quotationNumber=${EncryptedquotationNumber}&lang=${i18n.language}&payment=true`;
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: res.data.resultMessage,
              life: 6000,
            });
          }
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "System Error",
            life: 6000,
          });
        })
        .finally((e) => {
          dispatch(updateLoading(false));
        });
    },
  });
  const isFormFieldValid = (name) => !!formik.errors[name];
  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) ? formik.errors[name] : "";
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // Manually trigger validation
    const errors = await formik.validateForm();
    formik.setTouched({ ...formik.touched, ...formik.values });

    if (Object.keys(errors).length === 0) {
      // No validation errors, submit the form
      formik.handleSubmit();
    } else {
      // Perform any additional actions needed on invalid form submission
      scrollTo(refInfo);
    }
  };

  //----------------------------------------------------------------

  //--------------------------------------------
  // Load Required Data
  useEffect(() => {
    getDriverDetails(personalFormDetails, businessLine)
      .then((response) => {
        dispatch(updateLocalDriver(response));
      })
      .catch((error) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Motor Insurance ELM Lead Generation",
          funnel_step: "step_2",
          error_messages: error,
        });
      })
      .finally((e) => {});

    formik.validateForm();
  }, []);

  useEffect(() => {
    if (location.state?.lead) {
      if (Boolean(tmxVehicleDetails?.vehicleDetails?.vehicleDetailsArray?.length)) {
        let localVehicles = [];
        tmxVehicleDetails.vehicleDetails.vehicleDetailsArray.forEach((item) => {
          const vehicleObj = { ...VEHICLE_OBJECT, ...item };
          localVehicles.push(vehicleObj);
        });
        const tempSelectedVehicles = [];
        localVehicles.forEach((element) => {
          tempSelectedVehicles.push(element.chassisNumber);
        });
        dispatch(updateVehiclesDetails(localVehicles));
        formik.setFieldValue("vehicleList", tempSelectedVehicles);
      }
    }
  }, [tmxVehicleDetails]);
  //--------------------------------------------

  //--------------------------------------------
  // Get Proposal API Call
  const triggerGetProposal = (e) => {
    dispatch(updateLoading(true));
    const tempVehicleProposals = [];
    getProposal({ vehicles, customerDetails, promocode: "" }, "ALL", businessLine)
      .then((response) => {
        // FAIL
        // if (response.resultCode && response.resultCode !== "S") return;
        // SUCCESS
        response.forEach((item, i) => {
          tempVehicleProposals.push(item.value.data);
        });
        setProposalArray(tempVehicleProposals);
        // updateShowedProposals(tempVehicleProposals);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            funnel_step: "step_4",
            step_name: "elm_lead_generation_begin_checkout",
            items: [
              {
                item_name: "ELM Lead Generation",
                item_category: "Motor Insurance",
                item_class: "Individual",
                data_retrieval_method: "Registration Card",
                is_car_owner: "Yes",
                num_cars_added: tempVehicleProposals.length,
                driver_yob: getGregYearOfBirthList(tempVehicleProposals[0]?.gregDob),
                vehicle_count: tempVehicleProposals.length,
                vehicle_year: tempVehicleProposals[0]?.yearOfManufacture,
                vehicle_brand: tempVehicleProposals[0]?.makeName,
                vehicle_model: tempVehicleProposals[0]?.modelName,
              },
            ],
          },
        });
      })
      .catch((error) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Motor Insurance ELM Lead Generation",
          funnel_step: "step_4",
          error_messages: error,
        });
        if (retryCount < 5) {
          setRetryCount((prevRetryCount) => prevRetryCount + 1);
          // Debounce for 5 seconds
          setTimeout(() => {
            triggerGetProposal();
          }, 5000);
        }
      })
      .finally((e) => {
        dispatch(updateLoading(false));
      });
  };
  //--------------------------------------------

  //--------------------------------------------
  // update show proposals
  const updateShowedProposals = () => {
    const selectedProposals = [];
    const mergedProposals = [];
    const proposals = proposalArray;

    proposals?.forEach((item, i) => {
      if (formik.values.vehicleList.find((v) => item.vehicle === v)) {
        item.proposals?.proposalsArray?.forEach((proposal, i) => {
          if (allowedProp.find((p) => proposal.productSubCode === p)) {
            selectedProposals.push(proposal);
          }
        });
      }
    });

    allowedProp?.forEach((item, i) => {
      const merged = {
        productSubCode: item,
        premium: 0,
        list: [],
      };
      selectedProposals?.forEach((proposal, i) => {
        if (proposal.productSubCode === item) {
          merged.list.push(proposal);
          merged.premium += +proposal.premium;
        }
      });
      mergedProposals.push(merged);
    });
    proposals?.length && setSelectedProposalArray(mergedProposals);
    if (isFirstTime && selectedProposalArray.length > 0) {
      // mergedProposals.forEach((mp) => {
      //   if (mp.productSubCode === allowedProp[2] && mp.list.length) {
      //     formik.setFieldValue("proposalCode", allowedProp[2]);
      //   } else {
      //     formik.setFieldValue("proposalCode", allowedProp[1]);
      //   }
      // });
      let proposalArray = selectedProposalArray.filter((elm) => elm.premium > 0);
      formik.setFieldValue("proposalCode", proposalArray[proposalArray.length - 1].productSubCode);
      setIsFirstTime(false);
    }
  };
  //----------------------------------------------

  useEffect(() => {
    // Call updateShowedProposals whenever proposalArray or formik.values.vehicleList changes
    updateShowedProposals(proposalArray);
  }, [proposalArray, formik.values.vehicleList]);

  //----------------------------------------------
  // get proposals when vehicle changes

  useEffect(() => {
    formik.setFieldValue("vehicleList", [vehicles[0]?.chassisNumber]);
    if (vehicles[0]?.deductible && vehicles[0]?.modelCode) {
      !isSubmitting && triggerGetProposal();
    }

  }, [vehicles, isSubmitting]);

  //----------------------------------------------

  // display  price
  const getPrice = () => {
    const proposal = selectedProposalArray.find(
      (prop) => prop.productSubCode === formik.values.proposalCode
    );
    return proposal?.premium || "";
  };

  const loading = useSelector((state) => state.common.isLoading);

  return (
    <StyleWrapper>
      {loading && (
        <>
          <div className="loader-overlay">
            <img src={loaderLogo} alt="" />
          </div>
          <ProgressBar mode="indeterminate" color="#6B47F5" style={{ height: "6px" }}></ProgressBar>
        </>
      )}
      <Toast ref={toast} />

      <header className="header">
        <FullLogo />
        <LanguageSwitcherMobile />
      </header>

      <div className="container">
        <section>
          <LeadAccord customerDetails={customerDetails} />
        </section>

        <h3>{t("PolicyCoverage")}</h3>

        <section>
          <section className="d-flex gap-1 w-100">
            {selectedProposalArray?.map((proposal, index) => {
              return (
                <LeadProductCard
                  key={`VehiclePreviewCard_${index}`}
                  proposal={proposal}
                  formik={formik}
                />
              );
            })}
          </section>
        </section>

        <h3>{t("CoveredVehicles")}</h3>

        <section className="mb-4">
          {vehicles.map((vehicle, index) => {
            return (
              <VehicleCard
                key={`VehiclePreviewCard_${index}`}
                vehicle={vehicle}
                serialNumber={vehicle.serialNumber}
                triggerGetProposal={triggerGetProposal}
                formik={formik}
                setValidToGo={(e) => setValidToGo(e)}
              />
            );
          })}
        </section>

        <section className="d-flex flex-column w-100 gap-3">
          <MobileNumber
            name="mobile"
            value={formik.values.mobile}
            onChange={formik.handleChange}
            error={getFormErrorMessage("mobile")}
          />
          <LeadInput
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            label={t("other_info.email")}
            placeholder={"ex: example@example.com"}
            error={getFormErrorMessage("email")}
          />
        </section>
        <div className="my-3" ref={refInfo}>
          <Calender />
        </div>

        <div className="declaration mt-2">
          <Declaration formik={formik} />
          <Divider />{" "}
          <OtherInfo
            id="section-1"
            accordian={false}
            formik={formik}
            errorShow={false}
            nationalIdDisable={true}
            placeofIssueDisable={true}
            fullNameDisable={true}
            dobDisable={!!customerDetails?.gregDob}
            mobileNumberDisable={false}
            cityDisable={!!customerDetails?.cityCode}
            buildingDisable={
              !!customerDetails?.homeWaselBuildingNumber ||
              !!customerDetails?.officeWaselBuildingNumber
            }
            additionalNumberDisable={!!customerDetails?.officeWaselAdditionalNumber}
            identificationTypeDisable={true}
            regionDisable={!!customerDetails?.regionCode}
            streetDisable={
              !!customerDetails?.officeWaselEngStreetName ||
              !!customerDetails?.homeWaselEngStreetName
            }
            unitDisable={!!customerDetails?.officeSelfUnitNumber}
            zipDisable={!!customerDetails?.zipCode || !!customerDetails?.officeWaselPostalCode}
            activeIndex={1}
            setCityData={[]}
          />
        </div>
      </div>

      <footer className="footer">
        <Button onClick={handleFormSubmit} className="act-btn" disabled={!validToGo}>
          {t("PAY")} {numberWithCommas(getPrice()) + " " + t("SAR")}
        </Button>
      </footer>
    </StyleWrapper>
  );
};

export default LeadPolicyDetails;
